import styled from '@emotion/styled'
import MuiCheckbox from '@mui/material/Checkbox'
import MuiFormControlLabel from '@mui/material/FormControlLabel'
import { theme } from '../../themes/theme'
import { formSection } from './FormStyleConfig'

const Checkbox = styled(MuiCheckbox)`
  margin-right: 3px;

  .MuiSvgIcon-root {
    width: 20px;
    height: 20px;
  }
`

const FormControlLabel = styled(MuiFormControlLabel)`
  margin-top: ${props => (props.format !== undefined ? formSection[props.format].muiCheckbox.margin : formSection['default'].muiCheckbox.margin)};
  margin-bottom: ${props => (props.format !== undefined ? formSection[props.format].muiCheckbox.margin : formSection['default'].muiCheckbox.margin)};

  .MuiTypography-root {
    font-family: ${theme.fonts.body};
    font-size: ${props => (props.format !== undefined ? formSection[props.format].label.fontSize : formSection['default'].label.fontSize)};
    color: ${theme.colors.text.body};
  }

  .MuiFormControlLabel-asterisk {
    color: ${theme.colors.error};
  }

  .MuiButtonBase-root.MuiCheckbox-root.Mui-checked {
    color: ${theme.colors.primary} !important;
  }

  .MuiButtonBase-root.MuiCheckbox-root:hover {
    background-color: ${theme.colors.primaryExtraLight} !important;
  }

  .MuiButtonBase-root.MuiCheckbox-root {
    color: ${theme.colors.inputField.border};
  }

  .Mui-disabled {
    opacity: 0.8;
  }
`

// 22px flex cell that hosts a TableCheckbox in a table row or header.
const TableCheckboxCell = styled.div`
  display: flex;
  align-items: center;
  width: 22px;
  min-width: 22px;
`

// Label-less checkbox for table cells: no padding, primary when checked/indeterminate.
const TableCheckbox = styled(Checkbox)`
  padding: 0;
  margin-right: 0;
  color: ${theme.colors.inputField.border};

  &.Mui-checked,
  &.MuiCheckbox-indeterminate {
    color: ${theme.colors.primary};
  }

  :hover {
    background-color: ${theme.colors.primaryExtraLight};
  }
`

export { Checkbox, FormControlLabel, TableCheckbox, TableCheckboxCell }
